import { useEffect, useState } from "react";
import { User } from "../../../interfaces/interfaces";
import styles from "./ViewGroup.module.scss";
import { getTime } from "../../../components/functions/utilities";
import { MdOutlineRemoveCircleOutline } from "react-icons/md";
import { BsPlusCircle } from "react-icons/bs";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import { BsFillBarChartFill } from "react-icons/bs";
import { UsersRestS } from "../../../rest/users-rest-service";
import useModal from "../../../components/Hooks/useModal";
import EditGroupMembers from "./EditGroupMembers";

type Prop = {
  userGroup: any;
  allUsers: User[];
  onClose: Function;
  updateData: Function;
};

export default function ViewGroup({
  userGroup,
  allUsers,
  onClose,
  updateData,
}: Prop) {
  // console.log("all users", allUsers);
  const [userList, setUserList] = useState(allUsers);
  const [isAddMembers, setIsAddMembers] = useState(false);
  const [selectedMember, setSelectedMember] = useState<any>({});
  const [isGroupNameEdit, setIsGroupNameEdit] = useState<boolean>(false);
  let { toggle, visible } = useModal();
  const [groupName, setGroupName] = useState(userGroup.name);

  const renderName = (name) => {
    let userNameSplit = name.split(" ");
    return `${userNameSplit[0]?.charAt(0)}`.toUpperCase();
  };

  const deleteConfirm = () => {
    UsersRestS.deleteUserFromGroup(selectedMember?.id)
      .then((res) => {
        let data = userList.filter((e) => e.id != selectedMember?.id);
        setUserList(data);
      })
      .catch((e) => console.log(e));
  };

  const changeGroupName = (e) => {
    let name = e.target.value.trim();
    if (name == "") {
      name = "Untitled Group";
    }
    if (name.trim()) {
      UsersRestS.renameGroup(userGroup.id, name)
        .then((res) => {
          setGroupName(name);
          updateData();
        })
        .catch((e) => console.log(e));
    }
  };

  useEffect(() => {
    console.log("updating all users", allUsers);
    setUserList(allUsers);
  }, [allUsers]);

  return (
    <>
      <div className={`${styles.groupViewBlock}`}>
        <div className={styles.groupInfoSection}>
          <div
            className={styles.groupTitle}
            onClick={() => setIsGroupNameEdit(true)}
          >
            {isGroupNameEdit ? (
              <input
                className={styles.fullName}
                placeholder="Enter Group Name"
                onBlur={(e) => {
                  changeGroupName(e);
                }}
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
              />
            ) : (
              `${userGroup?.name}`
            )}
          </div>
          <div className={styles.groupInfo}>
            Owner: <span>{userGroup.username}</span>
          </div>
          <div className={styles.groupInfo}>
            Created on: <span>{getTime(userGroup.createdAt)}</span>
          </div>
          <div className={styles.addMember}>Members</div>
        </div>
        <div className={styles.groupMembers}>
          {userList &&
            userList.map((user: User, index) => {
              return (
                <div className={styles.membersList} key={index}>
                  <div className={styles.membersInfo}>
                    <div
                      style={{
                        backgroundColor: user.color
                          ? `#${user.color}`
                          : "#596de7",
                        cursor: "pointer",
                      }}
                      className={`${styles.profileImage}`}
                    >
                      {renderName(user.name)}
                    </div>
                    <div className={styles.membersNameDesignation}>
                      <div className={styles.membersName}>{user.name}</div>
                      <div className={styles.membersDesignation}>
                        {user.designation}
                      </div>
                    </div>
                  </div>
                  {userList.length > 1 ? (
                    <div
                      className={styles.icon}
                      onClick={() => {
                        setSelectedMember(user);
                        toggle();
                      }}
                    >
                      <MdOutlineRemoveCircleOutline />
                    </div>
                  ) : null}
                </div>
              );
            })}
        </div>
        <div className={styles.footer}>
          <div className="d-flex justify-content-center">
            <button className={styles.addBtn}>
              <span
                onClick={() => {
                  setIsAddMembers(true);
                }}
              >
                <BsPlusCircle className="me-2" />
                Add new user
              </span>
            </button>
          </div>
        </div>
      </div>

      <ConfirmDialog
        visible={visible}
        toggle={toggle}
        title={"Are you sure want to delete?"}
        activeBtnClick={deleteConfirm}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsFillBarChartFill />
        </div>
      </ConfirmDialog>
      {isAddMembers && (
        <EditGroupMembers
          users={userList}
          onClose={() => {
            setIsAddMembers(false);
          }}
          groupId={userGroup.id}
          setGroupUserList={setUserList}
        />
      )}
    </>
  );
}
